import { takeLatest } from 'redux-saga';
import { take, put, call } from 'redux-saga/effects';

import { loadDataAction,loadDataSuccessAction,loadDataErrorAction } from 'modules/app/actions';
import { deleteDoc as deleteDocActions } from '../actions';
import { DELETE_DOC } from '../constants/actionTypes';
import { removeDoc } from '../repository';


function *_deleteDoc(action) {
    const {utrac, id} = action;
    yield put(loadDataAction('deleteDoc'));

    try {
        yield call(removeDoc(utrac, id));
        yield put(deleteDocActions.success(id));
        yield put(loadDataSuccessAction('deleteDoc', 'doc.delete.success'));
    } catch (error) {
        yield put(deleteDocActions.error(error));
        yield put(loadDataErrorAction('deleteDoc', {response: error.response, body: error.body, titleId:'doc.delete.failed'}, action));
    }

}


export function *deleteDoc() {
    yield takeLatest(DELETE_DOC.REQUEST, _deleteDoc);
}